module.exports = __webpack_public_path__ + "img/search.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/search.png
// module id = 379
// module chunks = 0